import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Container, Row, Card, Form } from "react-bootstrap";
import { MdContentPaste } from "react-icons/md";
import Nav from "./Navbar";
import Footer from "./Footer";
import SideTab from "./Toolstab";
import ganalytic from "../Images/gsearch.png";
import {
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
  FaFileAlt,
  FaSearch,
} from "react-icons/fa";
import pay from "../Images/pay.png";
import { Helmet } from "react-helmet";
const Googleconsole = () => {
  const resultRef = useRef(null);

  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Google Search Console Insights for Better SEO Performance",
    url: "https://seobix.com/search-console",
    description:
      "Track site growth and clicks with Google Search Console. Improve SEO visibility, monitor performance, and optimize your website today!",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Google Search Console",
          item: "https://seobix.com/search-console",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Google Search Console",
      applicationCategory: "SEO Tool / Analytics",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free SEO Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      "google search console",
      "google console search",
      "can i search competitor website on google search console",
      "google search console vs google analytics",
      "difference between search console and google analytics",
      "google search console clicks vs google analytics sessions",
      "google search console domain vs url prefix",
      "search console google analytics",
      "search console in google analytics",
      "set up google search console",
      "setting up google search console",
      "add sitemap to google search console",
      "google search console expert",
      "google search console report template",
      "create google search console account",
    ],
    mainEntityOfPage: [
      {
        "@type": "Question",
        name: "What is Google Search Console?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Google Search Console is a free tool by Google that helps monitor, maintain, and troubleshoot your website's presence in Google Search results.",
        },
      },
      {
        "@type": "Question",
        name: "Why should I use Google Search Console?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "It helps track website growth, monitor clicks and impressions, fix errors, submit sitemaps, and improve SEO visibility.",
        },
      },
      {
        "@type": "Question",
        name: "Can Google Search Console help improve SEO?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, it provides valuable insights into website performance, keyword ranking, indexing status, and SEO errors, which can guide optimization strategies.",
        },
      },
    ],
  };

  return (
    <Container fluid className="p-0" style={{ overflowX: "clip" }}>
      <Helmet>
        <title>Google Search Console Insights for Better SEO Performance</title>
        <meta
          name="description"
          content="Track site growth and clicks with Google Search Console. Improve SEO visibility, monitor performance, and optimize your website today!"
        />
        <meta
          name="keywords"
          content="google search console, google console search, can i search competitor website on google search console, google search console vs google analytics, difference between search console and google analytics, google search console clicks vs google analytics sessions, google search console domain vs url prefix, search console google analytics, search console in google analytics, set up google search console, setting up google search console, add sitemap to google search console, google search console expert, google search console report template, create google search console account"
        />
        <link rel="canonical" href="https://seobix.com/search-console" />

        <meta
          property="og:title"
          content="Google Search Console Insights for Better SEO Performance"
        />
        <meta
          property="og:description"
          content="Track site growth and clicks with Google Search Console. Improve SEO visibility, monitor performance, and optimize your website today!"
        />
        <meta property="og:url" content="https://seobix.com/search-console" />
        <meta property="og:site_name" content="Seobix" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="600" />
        <meta property="og:locale" content="en_US" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Google Search Console Insights for Better SEO Performance"
        />
        <meta
          name="twitter:description"
          content="Track site growth and clicks with Google Search Console. Improve SEO visibility, monitor performance, and optimize your website today!"
        />
        <meta
          name="twitter:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta name="twitter:site" content="@seobix" />
        <meta name="twitter:creator" content="@seobix" />

        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
      </Helmet>

      <Nav />

      <div
        className="row d-flex justify-content-center pt-5"
        style={{
          background: "linear-gradient(to right, #f3f8ff, #ffffff)",
        }}
      >
        <Col md={10}>
          <Row className="" style={{ justifyContent: "space-between" }}>
            <Col md={8}>
              <ContentGoogleconsole />
            </Col>
            <Col md={3}>
              <div
                className="mb-5"
                style={{
                  position: "sticky",
                  top: "100px",
                  zIndex: 10,
                  background: "#f8f9fa",
                  padding: "1rem",
                  borderRadius: "10px",
                }}
              >
                <h5
                  className="text-center mb-4"
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.3rem",
                    color: "#fff",
                    backgroundColor: "#799EFF",
                    display: "inline-block",
                    padding: "6px 16px",
                    borderRadius: "0.5rem",
                  }}
                >
                  🚀 Explore More SEO Tools
                </h5>
                <SideTab />
              </div>
            </Col>
          </Row>
        </Col>
      </div>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

const ContentGoogleconsole = () => {
  return (
    <div>
      <Col>
        <h1 className="text-center mb-4" style={{ color: "#441752" }}>
          Google Search console & SEO Tools Integration by{" "}
          <span style={{ color: "#fc4100" }}>SeoBix</span>
        </h1>
        <Card className="p-4 mb-4 shadow-sm">
          <h4 style={{ color: "#003366" }}>
            Why Do You Need Google Search Console?
          </h4>
          <p>
            Search Console provides helpful hints for troubleshooting and
            improving visibility for search results, while Google Trends gives
            you the trends so you can target the popular topics. Google
            Analytics is able to track user behavior, including how well content
            works for those users; thus, you can optimize your content and
            measure the success of it. The tools combine to provide a wide
            overview of your website performance, facilitating your
            decision-making, leading to growth, and everything is taken care of
            from Seobix.
          </p>
        </Card>

        <Card className="p-4 mb-4 shadow-sm">
          <h4 style={{ color: "#003366" }}>
            1. Connects to Google Search Console
          </h4>
          <p>
            SeoBix integrates directly with your Google Search Console account
            using secure API access. When you authorize SeoBix, it pulls search
            performance data such as: <br />
            • Total clicks <br />
            • Total impressions <br />
            • Average CTR <br />
            • Average position <br />
            It retrieves this data for each page and keyword indexed on Google.
          </p>
          <Plancard />
          <h4 style={{ color: "#003366" }} className="mt-4">
            2. Pulls Keyword-Level Data
          </h4>
          <p>
            Once connected, it fetches detailed insights like: <br />
            • Which keywords are bringing traffic <br />
            • Their individual CTR, position, and impressions <br />
            • Keyword trends over time <br />
            This helps you see what’s ranking and where improvements are needed.
          </p>

          <h4 style={{ color: "#003366" }} className="mt-4">
            3. Analyze Page Performance
          </h4>
          <p>
            For every page on your website, SeoBix checks: <br />
            • What keywords it's ranking for <br />
            • How well it’s performing in search <br />
            • Which pages are gaining or losing visibility <br />
            This helps in understanding page-level SEO performance and planning
            content updates.
          </p>

          <h4 style={{ color: "#003366" }} className="mt-4">
            4. Shows Country-Wise & Device Data
          </h4>
          <p>
            SeoBix also pulls segmentation like: <br />
            • Country-based impressions and clicks <br />
            • Desktop vs mobile vs tablet data <br />
            • Performance by search appearance (if available) <br />
            This breakdown gives you more granular insights into your audience
            and behavior.
          </p>

          <h4 style={{ color: "#003366" }} className="mt-4">
            5. Tracks Historical Data
          </h4>
          <p>
            SeoBix stores and visualizes your search data over time, so you can
            track: <br />
            • Keyword growth <br />
            • Drops in visibility <br />
            • Performance spikes after updates or optimizations <br />
            Unlike Google Search Console (which limits historical data access),
            SeoBix stores more data longer for deeper comparisons.
          </p>
        </Card>

        <Card className="p-4 mb-4 shadow-sm">
          <h4 style={{ color: "#003366" }}>
            How Google Tools Help You Optimize, Track, and Grow Your Site?
          </h4>
          <p>
            Search Console, Trends, and Analytics are powerful aspects in your
            SEO journey. Each tool gives you a unique purpose, the data and
            insights needed to improve your website’s performance and increase
            traffic. Let's examine how you can use these tools to improve your
            website:
          </p>
          <ul>
            <li>
              <strong>Google Search Console:</strong> Tells you about the
              searches that bring in traffic, helps you understand how Google
              views your site, and detects problems that could impact your
              performance.
            </li>
            <li>
              <strong>Google Trends:</strong> Enables you to view popular
              subjects and phrases so that you may produce content that is very
              relevant to what people are looking for right now.
            </li>
            <li>
              <strong>Google Analytics:</strong> Tracks user behavior and shows
              how your content is performing, so you can refine and optimize
              your strategy based on real data.
            </li>
          </ul>
        </Card>
        <Plancard />
        <div className="text-center my-4">
          <img
            src={ganalytic}
            alt="Google Tools Overview"
            style={{
              maxWidth: "50vw",
              height: "auto",
              borderRadius: "1rem",
            }}
          />
        </div>

        <ToolSlider />
        <Specialoffer />
      </Col>
    </div>
  );
};

const relatedTools = [
  {
    name: "Google Trends Insights",
    icon: <FaSearch size={24} color="#0A3981" />,
    desc: "Know what is searching live all over the globe. Know what people are searching in real time so that you can align your content to what is trending themes and trends of the time.",
    href: "/trending-now-on-google",
  },
  {
    name: "Google Analytics Overview",
    icon: <FaChartBar size={24} color="#0A3981" />,
    desc: "Understand how users browse on your site. Bounce rates, track sessions and traffic sources to decide using the data and to optimize the performance.",
    href: "/google-analytics",
  },
  {
    name: "Search Console Monitor",
    icon: <FaFileAlt size={24} color="#0A3981" />,
    desc: "Test your position in Google search engine. Measure clicks, impressions and rankings of keywords in order to discover opportunities and correct index issues.",
    href: "/search-console",
  },
];
const ToolSlider = () => {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft -= 300;
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft += 300;
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={scrollLeft}
        style={{
          position: "absolute",
          left: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronLeft />
      </button>

      <button
        onClick={scrollRight}
        style={{
          position: "absolute",
          right: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronRight />
      </button>

      <div
        ref={sliderRef}
        className="mb-4"
        style={{
          display: "flex",
          overflowX: "auto",
          padding: "1rem",
          gap: "1rem",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
        }}
      >
        {relatedTools.map((tool, idx) => (
          <div
            key={idx}
            style={{
              minWidth: "250px",
              flex: "0 0 auto",
              background: "#f4f8ff",
              borderRadius: "12px",
              padding: "1rem",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              textAlign: "center",
              transition: "transform 0.3s",
            }}
          >
            <div style={{ marginBottom: "0.5rem" }}>{tool.icon}</div>
            <h6 style={{ color: "#0A3981", fontWeight: "bold" }}>
              {tool.name}
            </h6>
            <p
              style={{
                fontSize: "0.9rem",
                minHeight: "60px",
                lineHeight: "1.4",
              }}
            >
              {tool.desc
                .split(" ")
                .map((word, i) =>
                  (i + 1) % 7 === 0 ? word + "\n" : word + " "
                )
                .join("")
                .split("\n")
                .map((line, idx) => (
                  <span key={idx}>
                    {line.trim()}
                    <br />
                  </span>
                ))}
            </p>
            <a
              href={tool.href}
              style={{
                color: "#fff",
                backgroundColor: "#799EFF",
                padding: "6px 12px",
                borderRadius: "8px",
                textDecoration: "none",
                display: "inline-block",
                fontWeight: "bold",
              }}
            >
              Try Now →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Googleconsole;
